import React from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'
import { withFormik } from 'formik'
import * as yup from 'yup'

import { message, Form, Input, Button } from 'antd'

import { UPDATE_USER_PASSWORD } from '../../../../graphql/mutations'

const validationSchema = () =>
  yup.object().shape({
    oldPassword: yup.string().required('Password is required'),
    newPassword: yup
      .string()
      .required('New password is required')
      .notOneOf(
        [yup.ref('oldPassword'), null],
        'Passwords must not same as current password'
      )
  })

export const handleSubmit = async (values, { props, setSubmitting }) => {
  const { UpdateUserPassword } = props

  setSubmitting(true)

  try {
    const result = await UpdateUserPassword({
      variables: values
    })
    message.info(
      `User "${result.data.updateUserPassword.name}" update successful`
    )
  } catch (error) {
    message.error(error.message)
  }

  setSubmitting(false)
}

export const PasswordForm = ({
  handleSubmit,
  handleChange,
  handleBlur,
  touched,
  errors,
  dirty,
  isValid,
  isSubmitting
}) => (
  <Form layout="vertical" onSubmit={handleSubmit}>
    <Form.Item
      label="Current password"
      help={touched.oldPassword && errors.oldPassword ? errors.oldPassword : ''}
      validateStatus={
        touched.oldPassword && errors.oldPassword ? 'error' : undefined
      }
    >
      <Input.Password
        name="oldPassword"
        placeholder="Current password"
        type="password"
        onChange={handleChange}
        onBlur={handleBlur}
        autoComplete="off"
      />
    </Form.Item>
    <Form.Item
      label="New password"
      help={touched.newPassword && errors.newPassword ? errors.newPassword : ''}
      validateStatus={
        touched.newPassword && errors.newPassword ? 'error' : undefined
      }
    >
      <Input.Password
        name="newPassword"
        placeholder="New password"
        type="password"
        onChange={handleChange}
        onBlur={handleBlur}
        autoComplete="off"
      />
    </Form.Item>
    <Form.Item style={{ textAlign: 'center' }}>
      <Button
        type="primary"
        htmlType="submit"
        disabled={!dirty || !isValid || isSubmitting}
      >
        Change password
      </Button>
    </Form.Item>
  </Form>
)

PasswordForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  isValid: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired
}

export default compose(
  graphql(UPDATE_USER_PASSWORD, { name: 'UpdateUserPassword' }),
  withFormik({
    mapPropsToValues: ({ data: { me } }) => ({
      id: me && me.id,
      oldPassword: '',
      newPassword: ''
    }),
    handleSubmit,
    validationSchema,
    displayName: 'PasswordForm'
  })
)(PasswordForm)



// WEBPACK FOOTER //
// ./src/pages/Account/components/PasswordForm/index.js